// extracted by mini-css-extract-plugin
export default {"prefix":"name-prefix_prefix__r7oIc","prefix_active":"name-prefix_prefix_active__j7V-o"};